import CheckboxCheckDisabledSvg from "@/src/assets/icons/icon-checkbox-check-disable.svg";
import CheckboxCheckSvg from "@/src/assets/icons/icon-checkbox-check.svg";
import CheckboxDisabledSvg from "@/src/assets/icons/icon-checkbox-disabled.svg";
import UnCheckboxCheckSvg from "@/src/assets/icons/icon-checkbox-uncheck.svg";
import { forwardRef, InputHTMLAttributes } from "react";
import styled from "styled-components";

export interface CheckboxProps extends InputHTMLAttributes<HTMLInputElement> {}

const Checkbox = forwardRef<HTMLInputElement, CheckboxProps>((props, ref) => {
  return <StyledCheckbox type="checkbox" ref={ref} {...props} />;
});

const StyledCheckbox = styled.input`
  appearance: none;
  flex-shrink: 0;
  min-width: 18px;
  min-height: 18px;
  width: 18px;
  height: 18px;
  border: none;
  cursor: pointer;
  background: url(${UnCheckboxCheckSvg}) center/18px 18px no-repeat;

  &[type="checkbox" i] {
    margin: 0;
  }

  &:checked {
    background: url(${CheckboxCheckSvg}) center/18px 18px no-repeat;

    &:disabled {
      background: url(${CheckboxCheckDisabledSvg}) center/18px 18px no-repeat;
    }
  }

  &:disabled {
    background: url(${CheckboxDisabledSvg}) center/18px 18px no-repeat;
    cursor: not-allowed;
  }
`;

export default Checkbox;
